"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _map = _interopRequireDefault(require("./map"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var visibilityConfig = {
  options: [{
    name: 'outages',
    label: 'All Outages',
    default: true,
    layers: [{
      layerName: 'outages',
      zoom: [_map.default.minZoom, _map.default.maxZoom - 2]
    }, {
      layerName: 'both_tf',
      zoom: [_map.default.maxZoom - 1, _map.default.maxZoom]
    }]
  }, {
    name: 'outages_lite',
    label: 'All Outages',
    default: true,
    layers: [{
      layerName: 'outages_lite',
      zoom: [_map.default.minZoom, _map.default.maxZoom - 2]
    }, {
      layerName: 'both_tf',
      zoom: [_map.default.maxZoom - 1, _map.default.maxZoom]
    }]
  }, {
    name: 'regular_outages',
    label: 'Regular Outages',
    default: true,
    layers: [{
      layerName: 'regular_outages',
      zoom: [_map.default.minZoom, _map.default.maxZoom - 2]
    }, {
      layerName: 'both_tf',
      zoom: [_map.default.maxZoom - 1, _map.default.maxZoom]
    }]
  }, {
    name: 'critical_outages',
    label: 'Critical Outages',
    default: true,
    layers: [{
      layerName: 'critical_outages',
      zoom: [_map.default.minZoom, _map.default.maxZoom - 2]
    }, {
      layerName: 'both_tf',
      zoom: [_map.default.maxZoom - 1, _map.default.maxZoom]
    }]
  }, {
    name: 'managed_outages',
    label: 'Managed Outages',
    default: true,
    layers: [{
      layerName: 'managed_outages',
      zoom: [_map.default.minZoom, _map.default.maxZoom - 2]
    }, {
      layerName: 'both_tf',
      zoom: [_map.default.maxZoom - 1, _map.default.maxZoom]
    }]
  }, {
    name: 'both_outages',
    label: 'Both Outages',
    default: true,
    layers: [{
      layerName: 'both_outages',
      zoom: [_map.default.minZoom, _map.default.maxZoom - 2]
    }, {
      layerName: 'both_tf',
      zoom: [_map.default.maxZoom - 1, _map.default.maxZoom]
    }]
  }, {
    name: 'county',
    label: 'County',
    layers: [{
      layerName: 'thematic_county'
    }]
  }, {
    name: 'zip',
    label: 'Zip Code',
    layers: [{
      layerName: 'thematic_zip'
    }]
  }, {
    name: 'townWard',
    label: 'Town-Ward',
    layers: [{
      layerName: 'thematic_wards'
    }]
  }]
};
var _default = visibilityConfig;
exports.default = _default;